/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICRTouchConnection } from './ICRTouchConnection';
import {
    ICRTouchConnectionFromJSON,
    ICRTouchConnectionFromJSONTyped,
    ICRTouchConnectionToJSON,
    ICRTouchConnectionToJSONTyped,
} from './ICRTouchConnection';

/**
 * 
 * @export
 * @interface UpdateIcrTouchConnectionResponse
 */
export interface UpdateIcrTouchConnectionResponse {
    /**
     * 
     * @type {ICRTouchConnection}
     * @memberof UpdateIcrTouchConnectionResponse
     */
    data: ICRTouchConnection;
}

/**
 * Check if a given object implements the UpdateIcrTouchConnectionResponse interface.
 */
export function instanceOfUpdateIcrTouchConnectionResponse(value: object): value is UpdateIcrTouchConnectionResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateIcrTouchConnectionResponseFromJSON(json: any): UpdateIcrTouchConnectionResponse {
    return UpdateIcrTouchConnectionResponseFromJSONTyped(json, false);
}

export function UpdateIcrTouchConnectionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateIcrTouchConnectionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ICRTouchConnectionFromJSON(json['data']),
    };
}

  export function UpdateIcrTouchConnectionResponseToJSON(json: any): UpdateIcrTouchConnectionResponse {
      return UpdateIcrTouchConnectionResponseToJSONTyped(json, false);
  }

  export function UpdateIcrTouchConnectionResponseToJSONTyped(value?: UpdateIcrTouchConnectionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ICRTouchConnectionToJSON(value['data']),
    };
}

